import React from 'react'
import { useTranslation } from 'i18n'
import * as styles from './IncommOfferPicker.module.scss'

export interface OfferOption {
  offerId: string
  offerNumber: string
  status?: string
  availableStoreIds: string[]
  offerBannerImage: string
  offerExpirationDate?: string
}

export interface IncommOfferPickerProps {
  offers: OfferOption[]
  selectedOfferId?: string | null
  onSelectOffer: (offerId: string) => void
}

export const IncommOfferPicker = ({
  offers,
  selectedOfferId,
  onSelectOffer,
}: IncommOfferPickerProps) => {
  const { t } = useTranslation('incommOffer')

  return (
    <div className={styles.offerPickerContainer}>
      <h3 className={styles.pickerTitle}>{t('picker.title')}</h3>
      <div className={styles.offersGrid}>
        {offers.map(offer => (
          <div
            key={offer.offerId}
            className={`${styles.offerCard} ${
              selectedOfferId === offer.offerId ? styles.selected : ''
            }`}
            onClick={() => onSelectOffer(offer.offerId)}
            role="button"
            tabIndex={0}
            onKeyPress={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                onSelectOffer(offer.offerId)
              }
            }}
          >
            <div className={styles.imageWrapper}>
              <img
                src={offer.offerBannerImage}
                alt={t('picker.offerImageAlt', { number: offer.offerNumber })}
                className={styles.offerImage}
              />
              {selectedOfferId === offer.offerId && (
                <div className={styles.selectedBadge}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="12" fill="#007bff" />
                    <path
                      d="M7 12L10.5 15.5L17 9"
                      stroke="white"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
